interface TableHeader {
  text: string;
  value: string;
  sortable?: boolean;
}

/**
 * Generate headers by type
 * @param {string} source
 * @return {any}
 * */
export function useHeaders(source: string): any {
  let headers: TableHeader[] = [];
  switch (source) {
    case 'exercise':
      headers = [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Session',
          value: 'session.name',
          sortable: false,
        },
        {
          text: 'Questions',
          value: 'exercise',
          sortable: false,
        },
        {
          text: 'Reviews',
          value: 'review',
          sortable: false,
        },
      ];
      break;
    case 'question':
      headers = [];
      break;
    case 'homework':
      headers = [
        {
          text: 'Id',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Exercise',
          value: 'exercise',
          sortable: false,
        }
      ];
      break;
    case 'session':
      headers = [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Day',
          value: 'day',
          sortable: true,
        },
        {
          text: 'Warm Up',
          value: 'warmup',
          sortable: false,
        },
        {
          text: 'Questions',
          value: 'practices',
          sortable: false,
        },
        {
          text: 'Homework',
          value: 'homework',
          sortable: false,
        },
        {
          text: 'Badge',
          value: 'badge',
          sortable: false,
        },
        {
          text: 'Created',
          value: 'created',
          sortable: true,
        },
      ];
      break;
    case 'schedule':
      headers = [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Days',
          value: 'days',
          sortable: true,
        },
        {
          text: 'Users',
          value: 'users',
          sortable: true,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: true,
        },
      ];
      break;
    case 'coupon':
      headers = [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Code',
          value: 'code',
          sortable: true
        },
        {
          text: 'Type',
          value: 'type',
          sortable: true
        },
        {
          text: 'Created',
          value: 'created',
          sortable: true
        }
      ];
      break;
    default:
      headers = [];
      break;
  }
  return {
    headers,
  };
}
